import produce from "immer"
import { CcReviewReviewType } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initCcReviewReviewType: CcReviewReviewType = {
    id: null,
    accountId: null,
    projectId: null,
    name: "",
    creator: null,
    order: 0,
}

const initCcReviewReviewTypeState: types.CcReviewReviewTypeState = {
    typeList: {},
    typeIds: [],
    typeEdit: initCcReviewReviewType,

    reloadList: true,
    reloadEdit: true,
}

const ccReviewReviewTypeReducer = produce((
    draft: types.CcReviewReviewTypeState = initCcReviewReviewTypeState,
    action: ActionTypes = null,
): types.CcReviewReviewTypeState => {
    switch (action.type) {
        case types.CC_REVIEW_REVIEW_TYPE_LIST:
            draft.typeList = action.typeList
            return draft

        case types.CC_REVIEW_REVIEW_TYPE_IDS:
            draft.typeIds = action.typeIds
            return draft

        case types.CC_REVIEW_REVIEW_TYPE_EDIT:
            draft.typeEdit = action.value
            return draft

        case types.CC_REVIEW_REVIEW_TYPE_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.CC_REVIEW_REVIEW_TYPE_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default ccReviewReviewTypeReducer
